import React from 'react'
import ReactDOM from 'react-dom/client'
import App from '@/App'
import '@/index.css'

const rootElement = document.getElementById('root')

if (!rootElement) throw new Error('Failed to find the root element')

if (rootElement.innerHTML.trim()) {
  // Pre-rendered HTML exists — hydrate to attach event handlers
  ReactDOM.hydrateRoot(
    rootElement,
    <React.StrictMode>
      <App />
    </React.StrictMode>
  )
} else {
  // No pre-rendered HTML (dev mode) — create root normally
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  )
}
